export const MOMENT_DATE_FORMAT = "YYYY-MM-DD";
export const MOMENT_DATETIME_FORMAT = "YYYY-MM-DD HH:mm";
export const DEFAULT_LOCALE = "es";
export const DEFAULT_CURRENCY = 1;
export const MOMENT_TIME_FORMAT = "hh:mma";
